import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'orderTypeDialog.title',
    defaultMessage: 'Select type of order',
    description: 'Title of the order type dialog',
  },
  actions: {
    continue: {
      id: 'actions.continue',
      defaultMessage: 'Continue',
      description: 'Label of the continue action of the order type dialog',
    },
    cancel: {
      id: 'actions.cancel',
      defaultMessage: 'Cancel',
      description: 'Label of the cancel action of the order type dialog',
    },
  },
};

export default defineMessages(translations);
